import React, { useState,useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import "./Marquee.css"
import axios from 'axios';

const Marquee = () => {
  const [flashText,setFlashText] = useState([]);

   useEffect(() => {
      axios
        .get('https://api.bakpoket.com/api/AdminContent/get-Flash-Text?position=FlashText ')
        .then((res) => setFlashText(res.data))
        .catch((err) => console.error('API error:', err));
    }, []);

  return (
    <Wrapper>
      <ScrollText>{flashText.flashText}</ScrollText>
    </Wrapper>
  );
};

export default Marquee;

// ------------------- Styled Components -------------------

const marquee = keyframes`
  0%   { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

const Wrapper = styled.div`
  max-width:1280px;
  width: 100%;
  overflow: hidden;
  margin-bottom: 0px;
  white-space: nowrap;

  @media (max-width: 1280px) {
    margin-bottom: 0px;
    width: 100%;
  }
  @media (max-width: 576px) {
    margin-bottom: 0px;
    width: 100%;
  }
`;

// const ScrollText = styled.div`
//   display: inline-block;
//   padding: 4px 0;
//   font-size: 1.5rem;
//   font-weight: 600;
//   color: #2a4157;
//   animation: ${marquee} 12s linear infinite;

//   @media (max-width: 992px) {
//     font-size: 1.2rem;
//   }

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 0.75rem;
//   }
// `;
const ScrollText = styled.div`
  font-size: 1rem;
  white-space: nowrap;
  animation: ${marquee} 12s linear infinite;
  font-weight:bold;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.6rem;
  }
`;
